import withSlice from '@screens/SlicesContainer/withSlice';
import { mapWithMargins } from './mapImage';
import { IImageWithMargins } from './types';
import ResponsiveImage from '@monofront/design-system/components/ResponsiveImage';
import { useMediaQuery } from '@monofront/business/hooks';

const WithMargins: React.FC<IImageWithMargins> = ({ images }) => {
  const isMobile = useMediaQuery(800);

  return (
    <div className="tw-lf-layout-container tw-flex tw-flex-col tw-flex-nowrap tw-gap-3 desktop:tw-flex-row desktop:tw-gap-12">
      {images.map(({ image, mobileImage }) => {
        if (!image) {
          return null;
        }

        const imageToDisplay = isMobile ? mobileImage ?? image : image;

        return (
          <div key={image.url} className="tw-flex-[1_1_0]">
            <ResponsiveImage
              src={imageToDisplay.url}
              alt={imageToDisplay.alt ?? undefined}
              width={imageToDisplay.dimensions.width}
              height={imageToDisplay.dimensions.height}
            />
          </div>
        );
      })}
    </div>
  );
};

export default withSlice(WithMargins, mapWithMargins);
